import { useEffect } from "react";
import { useRouter } from "next/router";

import Loading from "components/shared/loading";

const Redirect = ({ to }) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(to);
  }, [to]);

  return <Loading />;
};

export default Redirect;
